// extracted by mini-css-extract-plugin
export default {"title":"AccountDetail_title__Hh53I","loading":"AccountDetail_loading__aOPxM"};